var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[(_vm.isLoading)?_c('b-col',[_c('Loader',{attrs:{"size":"lg"}})],1):_c('b-col',[_c('UserDataAddressForm',{attrs:{"handle-submit":_vm.onSendForm,"handle-update-field":_vm.updateField,"values":_vm.item,"errors":_vm.violations}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }